import React from 'react'

function Play() {
    return (
        <div>
            Play
        </div>
    )
}

export default Play
